import React from 'react';
import { warningIcon } from './icons';

type WarningProps = {
    children: React.ReactNode;
};

export const Warning = (props: WarningProps) => {
    const [isOpen, setIsOpen] = React.useState(false);

    const setClosed = () => {
        setIsOpen(false);
    }

    const setOpen = () => {
        setIsOpen(true);
    }

    if (!props.children) {
        return null;
    }
    return (
        <aside
            className="warning"
            onClick={setClosed}
            onMouseLeave={setClosed}>
            <div
                onClick={e => { setOpen; e.stopPropagation(); }}
                onMouseOver={setOpen}>
                {warningIcon}
            </div>
            <article
                className={isOpen
                    ? 'documentation__article--open'
                    : 'documentation__article--closed'}>
                {props.children}
            </article>
        </aside>
    );
}
